import { BASE_URL } from "./apis";

const ApiCall = async (url, method, data) => {
  try {
    // Retrieve the authToken from local storage
    const token = localStorage.getItem("userToken");
    const jsonToken = JSON.parse(token);
    const completeUrl = BASE_URL + url;
    let headers = new Headers({
      Accept: "application/json",
      "Content-Type":
        data instanceof FormData ? "multipart/form-data" : "application/json",
    });

    if (jsonToken) {
      headers.append("Authorization", `Bearer ${jsonToken}`);
    }

    const requestOptions = {
      method: method,
      headers: headers,
    };

    if (data) {
      requestOptions.body = data;
    }


    const response = await fetch(completeUrl, requestOptions);
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("api error:", error);
    return { message: error, status: false, ok: false };
  }
};

export default ApiCall;
